module.exports = "/fonts/fa-brands-400.woff2?a06da7f0950f9dd366fc9db9d56d618a";